export const ModelParseServiceModule = angular
    .module('app.services.data.modelService.modelParser', [])
    .service('modelParser', ($injector) => {
        var api = {
            parse: parse
        };

        return api;

        function getKeysFromString(str) {
            var obj = $injector.get(str);
            return getKeysFromObject(obj);
        }

        function getKeysFromArray(arr) {
            var newObj = {};
            for (let i = 0; i < arr.length; i += 1) {
                let name = arr[i];
                newObj[name] = null;
            }

            return newObj;
        }

        function getKeysFromObject(settings) {
            let model = {};

            Object.keys(settings).forEach((i) => {
                model[i] = getDefault(settings[i]);
            });

            return model;
        }

        function getDefault(item) {
            switch (item) {
                case 'any':
                    return null;
                case 'String':
                    return '';
                case 'Number':
                    return null;
                case 'Boolean':
                    return false;
                case 'Array':
                    return [];
                default:
                    if (Array.isArray(item)) {
                        //if item has default, use that, otherwise use type
                        return item.length === 2 ? item[1] : getDefault(item[0]);
                    } else if (typeof item === 'object') {
                        return getKeysFromObject(item);
                    }

                    throw new Error(`Unsupported type ${item} used`);
            }
        }

        function parse(model) {
            if (typeof model === 'string') {
                return getKeysFromString(model);
            } else if (Array.isArray(model)) {
                return getKeysFromArray(model);
            }

            return getKeysFromObject(model);
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/model/modelParse.service.js